import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';

import Prismic from 'prismic-javascript';

import { accessToken, apiEndpoint, PrismicType } from '@app/config';
import { TradeUrlSchema } from '@hoa/schema';

//  - Implementation of legacy prismic to be able to have preview since docs request next 13
export const PrismicClientLegacy = (req = null) =>
  Prismic.client(apiEndpoint || ``, createClientOptions(req, accessToken));

const createClientOptions = (
  req = null,
  prismicAccessToken: string | undefined,
) => {
  const reqOption = req ? { req } : {};
  const accessTokenOption = prismicAccessToken
    ? { accessToken: prismicAccessToken }
    : {};

  return {
    ...reqOption,
    ...accessTokenOption,
  };
};

type Fragment =
  | `document.type`
  | `my.page.uid`
  | `my.city.uid`
  | `document.id`
  | `my.category_page.uid`
  | `my.category_city_page.uid`;

export interface Options {
  [key: string]: string | number | string[];
}

const getMethod = async (
  fragment: Fragment,
  value: PrismicType | string,
  options?: Options,
) => {
  return await PrismicClientLegacy().query(
    Prismic.Predicates.at(fragment, value),
    options,
  );
};

export const PrismicGateway = { get: getMethod };

const linkResolver = (doc: any) => {
  console.log("doc", doc)
  if (doc.type === `offer_page`) {
    return `/${doc.lang.slice(0, 2)}/services/${doc.uid}`;
  }
  if (doc.type === `category_page`) {
    // @ts-ignore
    return `/${doc.lang.slice(0, 2)}/${TradeUrlSchema[doc.lang.slice(0, 2)][doc.uid]}`;
  }

  if (doc.type === `page`) {
    return `/${doc.lang.slice(0, 2)}/service/${doc.uid}`;
  }


  return `/${doc.uid}`;
};

const Preview = () => {
  const router = useRouter();

  useEffect(() => {
    const { token: ref, documentId } = router.query;

    if (ref && documentId) {
      localStorage.setItem(`previewToken`, ref as string);

      PrismicClientLegacy()
        .getPreviewResolver(ref as string, documentId as string)
        .resolve(linkResolver, '/')
        .then(async (url) => await router.push(`${url}?preview=true`));
    }
  }, [router]);

  return (
    <section>
      <Head>
        <title>Prismic Preview</title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <main>
        <h1>Preview</h1>
        <p>Waiting for redirect</p>
      </main>
    </section>
  );
};

export default Preview;
